var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "cog-stripe-payment" },
    [
      _vm.showLoader
        ? _c("stripe-card-placeholder", { attrs: { mobile: _vm.mobile } })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "stripe-card",
        {
          ref: "card",
          attrs: {
            "publishable-key": _vm.apiKey,
            locale: _vm.$culture.name,
            "input-styles": _vm.inputStyles,
            amount: _vm.orderAmountCents,
            "save-card": _vm.saveCard,
            "payment-required": _vm.paymentRequired,
            currency: _vm.currency,
            "billing-details": _vm.billingDetails,
            "use-wallets": _vm.useWallets
          },
          on: {
            ready: _vm.handlePaymentElementReady,
            focus: _vm.handleFocus,
            blur: _vm.handleBlur,
            change: _vm.handleChange
          }
        },
        [
          _c("div", {
            staticClass: "cog-payment__frame cog-field",
            attrs: { id: "cog-payment-element" }
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }